// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardSettingsPopup_root__qB6SR {
  max-width: 100% !important;
}

.DashboardSettingsPopup_filter_group__5SM2T {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.DashboardSettingsPopup_filter_group_item__CZfId {
  width: 30%;
}

.DashboardSettingsPopup_kpi_settings_container__L\\+e3W {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  text-align: center;
}

.DashboardSettingsPopup_kpi_item__JIiT4 {
  display: flex;
  width: 20%;
  /* width: 30%; */
  height: 10vh;
  /* padding-bottom: 5%; */
  /* align-content: center; */
  align-items: center;
  text-align: center;
  padding-left: 5px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  cursor: pointer;

  /* max-width: 30% !important; */
  /* margin-right: 3.2%; */
}

.DashboardSettingsPopup_kpi_item__JIiT4:hover {
  background-color: var(--color-bg-sidebar-item-hover) !important;
}

.DashboardSettingsPopup_kpi_value__opULI {
  max-width: 90px;
  word-wrap: break-word;
}

.DashboardSettingsPopup_add_kpi_text__x4EAF {
  margin: auto;
  color: rgb(171, 171, 171);
}

.DashboardSettingsPopup_chart_settings_row__WNv7s {
  display: flex;
  /* flex-wrap: wrap; */
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.DashboardSettingsPopup_kpi_clear_icon__el8Uy {
  /* max-width: 2%; */

  margin-top: 35px;
  margin-left: 2px;
  /* margin-right: 5px; */
  cursor: pointer;
}

.DashboardSettingsPopup_chart_setting__PoCJf {
  width: 27%;
}

.DashboardSettingsPopup_chart_currency_filter__HzAnS {
  width: 13%;
}
.DashboardSettingsPopup_chart_clear_icon__WF6lE {
  width: 5%;
  cursor: pointer;
}

.DashboardSettingsPopup_add_chart_button__Pa1dn {
  border: solid 0.5px black !important;
}

.DashboardSettingsPopup_loading__RkGRP {
  margin: auto 50px;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/DashboardSettingsPopup/DashboardSettingsPopup.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;;EAEf,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;;EAEnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;AACA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".root {\n  max-width: 100% !important;\n}\n\n.filter_group {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.filter_group_item {\n  width: 30%;\n}\n\n.kpi_settings_container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  text-align: center;\n}\n\n.kpi_item {\n  display: flex;\n  width: 20%;\n  /* width: 30%; */\n  height: 10vh;\n  /* padding-bottom: 5%; */\n  /* align-content: center; */\n  align-items: center;\n  text-align: center;\n  padding-left: 5px;\n  border: 1px solid #ccc;\n  margin-bottom: 10px;\n  cursor: pointer;\n\n  /* max-width: 30% !important; */\n  /* margin-right: 3.2%; */\n}\n\n.kpi_item:hover {\n  background-color: var(--color-bg-sidebar-item-hover) !important;\n}\n\n.kpi_value {\n  max-width: 90px;\n  word-wrap: break-word;\n}\n\n.add_kpi_text {\n  margin: auto;\n  color: rgb(171, 171, 171);\n}\n\n.chart_settings_row {\n  display: flex;\n  /* flex-wrap: wrap; */\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.kpi_clear_icon {\n  /* max-width: 2%; */\n\n  margin-top: 35px;\n  margin-left: 2px;\n  /* margin-right: 5px; */\n  cursor: pointer;\n}\n\n.chart_setting {\n  width: 27%;\n}\n\n.chart_currency_filter {\n  width: 13%;\n}\n.chart_clear_icon {\n  width: 5%;\n  cursor: pointer;\n}\n\n.add_chart_button {\n  border: solid 0.5px black !important;\n}\n\n.loading {\n  margin: auto 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `DashboardSettingsPopup_root__qB6SR`,
	"filter_group": `DashboardSettingsPopup_filter_group__5SM2T`,
	"filter_group_item": `DashboardSettingsPopup_filter_group_item__CZfId`,
	"kpi_settings_container": `DashboardSettingsPopup_kpi_settings_container__L+e3W`,
	"kpi_item": `DashboardSettingsPopup_kpi_item__JIiT4`,
	"kpi_value": `DashboardSettingsPopup_kpi_value__opULI`,
	"add_kpi_text": `DashboardSettingsPopup_add_kpi_text__x4EAF`,
	"chart_settings_row": `DashboardSettingsPopup_chart_settings_row__WNv7s`,
	"kpi_clear_icon": `DashboardSettingsPopup_kpi_clear_icon__el8Uy`,
	"chart_setting": `DashboardSettingsPopup_chart_setting__PoCJf`,
	"chart_currency_filter": `DashboardSettingsPopup_chart_currency_filter__HzAnS`,
	"chart_clear_icon": `DashboardSettingsPopup_chart_clear_icon__WF6lE`,
	"add_chart_button": `DashboardSettingsPopup_add_chart_button__Pa1dn`,
	"loading": `DashboardSettingsPopup_loading__RkGRP`
};
export default ___CSS_LOADER_EXPORT___;
